import React from 'react';
import { portfolioData } from '../data/portfolio-data';

const AboutSection: React.FC = () => {
  const bloom = portfolioData.find(p => p.title === 'Bloom Elixirs');
  const vps = portfolioData.find(p => p.title.includes('VPS Automation'));
  const trafficGrowth = bloom?.['traffic growth']?.replace('+', '') || '';
  const beforeRecovery = vps?.performanceMetrics?.beforeOptimization?.recoveryTime || '';
  const afterRecovery = vps?.performanceMetrics?.afterOptimization?.recoveryTime || '';
  const recoveryText = beforeRecovery && afterRecovery
    ? `Recovery Time: ${beforeRecovery.replace(/ hours?/, ' hrs')} → ${afterRecovery.replace(/ min(ute)?s?/, ' mins')} (${vps?.title})`
    : '';
  const shee = portfolioData.find(p => p.title === 'Shee & Fowl');
  const buildTime = shee?.['build time'] || '';

  const navigateToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const offset = 100;
      const elementPosition = section.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: elementPosition, behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="my-24 py-24 bg-gradient-to-b from-blue-900 to-blue-800">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center px-6 md:px-12 gap-12">
        {/* Headshot */}
        <div className="flex-shrink-0">
          <img src="/images/profile_pic.jpg" alt="Nicholas Solomon headshot" className="w-48 h-48 rounded-full object-cover border-4 border-blue-500 shadow-lg" />
        </div>
        {/* Content */}
        <div className="flex-1 space-y-8 text-left">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Empowering Entrepreneurs with Enterprise-Level Systems
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {trafficGrowth && (
              <div className="bg-blue-800 p-6 rounded-lg shadow-inner">
                <span className="text-3xl font-bold text-cyan-300">{trafficGrowth}</span>
                <p className="text-blue-200 mt-2">Traffic Growth</p>
                <p className="text-blue-400 text-sm">{bloom?.title}</p>
              </div>
            )}
            {recoveryText && (
              <div className="bg-blue-800 p-6 rounded-lg shadow-inner">
                <span className="text-3xl font-bold text-cyan-300">{beforeRecovery}→{afterRecovery}</span>
                <p className="text-blue-200 mt-2">Recovery</p>
                <p className="text-blue-400 text-sm">{vps?.title}</p>
              </div>
            )}
            {buildTime && (
              <div className="bg-blue-800 p-6 rounded-lg shadow-inner">
                <span className="text-3xl font-bold text-cyan-300">{buildTime}</span>
                <p className="text-blue-200 mt-2">Build Time</p>
                <p className="text-blue-400 text-sm">{shee?.title}</p>
              </div>
            )}
          </div>
          <p className="text-blue-200 text-lg">
            After a career engineering mission-critical systems in the U.S. military and private tech consulting, I created AISS to bridge the gap between big business technology and everyday entrepreneurs.
          </p>
          <button
            onClick={() => {
              if (window.Calendly) {
                window.Calendly.initPopupWidget({ url: 'https://calendly.com/nicksolo96/30min' });
              } else {
                console.warn('Calendly widget not loaded');
              }
            }}
            className="mt-4 px-8 py-3 bg-cyan-400 hover:bg-cyan-500 text-blue-900 font-semibold rounded-full"
          >
            Let's Build Your Solution
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;